import * as d3 from "d3"
import * as shared from "./shared"
import { SvgEventHandlers } from "./types"

export const register = (
  svgElement: SVGSVGElement,
  handlers?: SvgEventHandlers,
): (() => void) => {
  d3.select(svgElement).on("dblclick", function (event: MouseEvent) {
    const { buttonTarget } = shared.mouseTarget(event)
    if (handlers?.doubleClick) {
      handlers?.doubleClick?.(buttonTarget, event)
    }
  })

  return () => d3.select(svgElement).on("dblclick", null)
}
